export const mapFacturaPendienteToFacturaPost = ({
  values,
}: $TSMigrationFixMe) => {
  const valuesToPost = {
    documentoImportadoId: values.id,
    divisa: values.divisa,
    librado: {
      nif: values.libradoNif,
      razonSocial: values.libradoRazonSocial,
      codigoPais: values.libradoPais,
    },
    librador: {
      nif: values.libradorNif,
      razonSocial: values.libradorRazonSocial,
      codigoPais: values.libradorPais,
    },
    serie: values.numero,
    fechaEmision: values.fechaFactura,
    importe: values.total,
    totalRepercutido: values.totalImpuestos,
    totalRetenido: values.totalRetencion,
    empresaCreacionId: values.empresaCreacionId,
    empresaCreacion: values.empresaCreacion,
    impuestos: values.impuestos,
    retencion: values.retencion,
  }

  return valuesToPost
}
